// Guest user constants

// Cookie configuration
export const GUEST_COOKIE_NAME = 'memorised_guest_uid';
export const GUEST_COOKIE_EXPIRY_DAYS = 30;

// Modal view states
export const MODAL_VIEWS = {
  LOGIN: 'login',
  SIGNUP: 'signup',
  SUCCESS: 'success',
};

// Guest cart storage key
export const GUEST_CART_STORAGE_KEY = 'guest_cart';
